module.exports = __webpack_public_path__ + "static/cg_role_178_00076670af1.wav";